import {MDBBadge} from "mdb-react-ui-kit";
import {Link} from "react-router-dom";
import React from "react";
import {getEmployeeInfo} from "./EmployeeInfo";

export function loadEmployees(sort, search, filter) {

    const returnList = [];

    if (search.length !== 0 && !search.includes("didn't match any employees")) {
        for (const employee in search) {
            const employeeInfo = getEmployeeInfo(search[employee]);
            returnList.push(
                <div>
                    <div className="list-section">
                        <h3 className="list-section-header">{search[employee].name}
                            <MDBBadge pill className='info_float mt-0' color='info_float'> {employeeInfo[2]}</MDBBadge>
                        </h3>

                        <Link to={"/management/employees/view"} state={search[employee]}>
                            <button className="btn btn-primary list-section-btn float-right"> View Details</button>
                        </Link>
                        <p className="list-section-date-time">{employeeInfo[0]} {employeeInfo[1]}</p>
                        <br/><br/>
                    </div>
                    <br/>


                </div>
            );
        }
    } else if (search.length !== 0) {
        returnList.push(
            <div>
                <h3 className="search-message"> {search} </h3>
            </div>
        )
    }

    if (search.length !== 0) {
        returnList.push(
            <div>
                <hr/>
                <br/>
            </div>
        )
    }

    if (filter.length !== 0 && !filter.includes("didn't match any employees")) {
        for (const employee in filter) {
            const employeeInfo = getEmployeeInfo(filter[employee]);
            returnList.push(
                <div>
                    <div className="list-section">
                        <h3 className="list-section-header">{filter[employee].name}
                            <MDBBadge pill className='info_float mt-0' color='info_float'> {employeeInfo[2]}</MDBBadge>
                        </h3>

                        <Link to={"/management/employees/view"} state={filter[employee]}>
                            <button className="btn btn-primary list-section-btn float-right"> View Details</button>
                        </Link>
                        <p className="list-section-date-time">{employeeInfo[0]} {employeeInfo[1]}</p>
                        <br/><br/>
                    </div>
                    <br/>


                </div>
            );
        }
    } else if (filter.length !== 0) {
        returnList.push(
            <div>
                <h3 className="search-message"> {search} </h3>
            </div>
        )
    }
    //Could filter here so only the search results are displayed?
    if (filter.length === 0) {
        for (const job in sort) {
            const jobInfo = getEmployeeInfo(sort[job]);
            returnList.push(
                <div>
                    <div className="list-section">
                        <h3 className="list-section-header">{sort[job].name}
                            <MDBBadge pill className='info_float mt-0' color='info_float'> {jobInfo[2]}</MDBBadge>
                        </h3>

                        <Link to={"/management/employees/view"} state={sort[job]}>
                            <button className="btn btn-primary list-section-btn float-right"> View Details</button>
                        </Link>
                        <p className="list-section-date-time">{jobInfo[0]} {jobInfo[1]}</p>
                        <br/><br/>
                    </div>
                    <div className="page-break"></div>
                </div>
            );
        }
    }
    return returnList;

}